import React, { Component, Fragment } from 'react';
import { Container, Row, Col, Input, Label, Button, Form, FormGroup } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faCircle, faTrashAlt, faGripLines } from '@fortawesome/free-solid-svg-icons'
import { faCircle as faCircleOutline } from '@fortawesome/free-regular-svg-icons'
import ReactDragListView from 'react-drag-listview'
import PermissionWrapper from '../../auth/PermissionWrapper';
import ConfirmButton from '../Modal/ConfirmButton';

class Forms extends Component {

    standardRow = (form) => {
        this.props.info('Forms.js/standardRow (form)', form);
        return (
            <Row className="adminRow pointer formRow" onClick={() => this.props.onEdit(form.formId)}>
                <Col md={4} className="text-left">
                    <FontAwesomeIcon icon={(form['active']) ? faCircle : faCircleOutline} className={"mr-3 " + ((form['active']) ? 'iconActive' : 'iconInactive')} />
                    {form['name']}
                </Col>
                <Col md={7} className="text-left"></Col>
                {this.props.editForm.formId === 0 ?
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Reorder Forms">
                        <Col md={1} className="text-right">
                            <span className="dragIcon p-2"><FontAwesomeIcon icon={faGripLines} /></span>
                        </Col>
                    </PermissionWrapper>
                    : <></>}
            </Row>
        )
    }

    editRow = (form) => {
        this.props.log('Forms.js/editRow (form)', form);
        return (<>
            <Row key={"edit" + form.formId} className={"adminRow activeTab"}>
                <Col md={9} className={"text-left pl-5"}>
                    <Form inline>
                        <FormGroup className="pr-2">
                            <Input
                                placeholder="Name"
                                type="text"
                                id={"edit-name" + form.formId}
                                name="name"
                                value={this.props.isFieldNull(this.props.editForm.name)}
                                onChange={e => this.props.onChange(e, 'edit')} />
                        </FormGroup>
                        <FormGroup className="px-2">
                            <Input
                                type="checkbox"
                                id={"edit-active" + form.formId}
                                name="active"
                                checked={this.props.isFieldNull(this.props.editForm.active, true)}
                                onChange={e => this.props.onChange(e, 'edit')} />
                            <Label for={"edit-active" + form.formId}>
                                Active
                            </Label>
                        </FormGroup>
                    </Form>
                </Col>
                <Col md={3} className="text-right">
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Forms">
                        <Button className="mx-1" color="success" onClick={() => this.props.handleEdit()} title="Edit Form">
                            <FontAwesomeIcon icon={faCheck} />
                        </Button>
                    </PermissionWrapper>
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Delete Forms">
                        <ConfirmButton className="mx-3" color="danger" onClick={() => this.props.onDelete(form.formId)}>
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </ConfirmButton>
                    </PermissionWrapper>
                    <Button className="mx-1" color="secondary" onClick={() => this.props.handleCancel()} title="Cancel">
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </Col>
                <Col md={1}></Col>
                <Col md={2} className="text-right py-3 px-0">
                    Form Fields
                </Col>
                <Col md={4} className="text-left py-3">
                    <ReactDragListView {...this.props.dragPropsFields}>
                        {[...this.props.formFields].map(formField => {
                            const thisFormFields = this.props.editForm.formFields;
                            const newOrder = (thisFormFields.findIndex(item => item.formFieldId === formField.formFieldId) > -1) ?
                                thisFormFields[thisFormFields.findIndex(item => item.formFieldId === formField.formFieldId)].order : formField.order * 100000;
                            return ({
                                ...formField,
                                order: newOrder
                            })
                        })
                            .sort((a, b) => a.order - b.order)
                            .map(formField => (
                                <Row className="fieldRow pointer" key={formField.formFieldId}>
                                    <Col md={2}><span className="dragIcon p-2"><FontAwesomeIcon icon={faGripLines} /></span></Col>
                                    <Col md={10}>
                                        <Label key={formField.formFieldId} for={"formField_" + formField.formFieldId}>
                                            <Input
                                                type="checkbox"
                                                name="formFields"
                                                id={"formField_" + formField.formFieldId}
                                                checked={this.props.isFieldNull(this.props.editForm.formFields.findIndex(i => i.formFieldId === parseInt(formField.formFieldId)) > -1, true)}
                                                onChange={e => this.props.onChange(e, 'edit')}
                                            />{formField.field}
                                        </Label>
                                    </Col>
                                </Row>
                            ))}
                    </ReactDragListView>
                </Col>
                <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Form Configuration">
                    <Col md={5} className="pt-4">
                        <Label for={"edit-config" + form.formId}>
                            Configuration
                        </Label>
                        <Input
                            type="textarea"
                            name="config"
                            id={"edit-config" + form.formId}
                            onChange={e => this.props.onChange(e, 'edit')}
                            value={this.props.isFieldNull(this.props.editForm.config)}
                            rows={24}
                        />
                    </Col>
                </PermissionWrapper>
            </Row>
        </>
        )
    }

    addRow = () => {
        this.props.info('Forms.js/addRow');
        return (
            <Row className="py-4 text-left align-items-bottom ">
                <Col md={10} className="pl-5">
                    <Form inline>
                        <FormGroup className="pr-2">
                            <Input
                                placeholder="New Form Name"
                                type="text"
                                id={"form-add-name"}
                                name="name"
                                value={this.props.isFieldNull(this.props.newForm.name)}
                                onChange={e => this.props.onChange(e, '')} />
                        </FormGroup>
                        <FormGroup className="px-2">
                            <Input
                                type="checkbox"
                                id={"form-add-active"}
                                name="active"
                                checked={this.props.isFieldNull(this.props.newForm.active, true)}
                                onChange={e => this.props.onChange(e, '')} />
                            <Label for={"form-add-active"}>
                                Active
                            </Label>
                        </FormGroup>
                        <FormGroup className="px-2">
                            <Input
                                type="textarea"
                                name="config"
                                id={"form-add-config"}
                                onChange={e => this.props.onChange(e, '')}
                            />
                            <Label for={"form-add-config"}>
                                Configuration
                            </Label>
                        </FormGroup>
                    </Form>
                </Col>
                <Col md={2} className="text-right">
                    <Button
                        disabled={this.props.newForm.name === ''}
                        color="primary"
                        onClick={() => this.props.handleAdd()}
                    >Add Form</Button>
                </Col>
            </Row>
        )
    }

    render() {
        this.props.info('Forms.js/render');
        return (
            <Container className="adminContainer" fluid>
                <ReactDragListView {...this.props.dragProps}>
                    {this.props.forms.map(form => (
                        <Fragment key={form.formId}>{this.props.editForm.formId === form.formId ?
                            <>{this.editRow(form, true)}
                                {this.addRow()}
                            </> : this.standardRow(form, true)}</Fragment>
                    ))}
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Forms">
                        {this.props.editForm.formId === 0 ? this.addRow(true) : null}
                    </PermissionWrapper>
                </ReactDragListView>
            </Container>
        );

    }
}

export default Forms;
